require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/@xlts.dev/angular/index.js
// module id = 441
// module chunks = 0